import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number, currency: string = 'BRL'): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
  }).format(value);
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('pt-BR');
}

export function getDaysUntil(date: string | Date): number {
  const target = new Date(date);
  const today = new Date();
  const diffTime = target.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function getContractStatusColor(status: string): string {
  const colors: Record<string, string> = {
    draft: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100',
    active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100',
    suspended: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100',
    terminated: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100',
    expired: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100',
  };
  return colors[status] || colors.draft;
}

export function getContractStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    draft: 'Rascunho',
    active: 'Ativo',
    suspended: 'Suspenso',
    terminated: 'Encerrado',
    expired: 'Expirado',
  };
  return labels[status] || status;
}

export function getContractTypeLabel(type: string): string {
  const labels: Record<string, string> = {
    payable: 'A Pagar',
    receivable: 'A Receber',
  };
  return labels[type] || type;
}
